import styled from "styled-components";

const DashboardMedia = {
  desktop: "@media(min-width: 768px)",
};

export const ContainerDash = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap");

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #000000;
  font-family: "Inter", sans-serif;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 290px;
    height: 65px;
    border-bottom: 1px solid #212529;
    ${DashboardMedia.desktop} {
      width: 700px;
    }
  }
  header button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 17px;
    width: 55px;
    height: 32px;
    background: #212529;
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 23px;
    text-align: center;
    color: #f8f9fa;
    cursor: pointer;
  }
`;

export const User = styled.div`
  width: 290px;
  height: 95px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  border-bottom: 1px solid #212529;
  ${DashboardMedia.desktop} {
    width: 700px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #f8f9fa;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: #868e96;
  }
`;

export const Tech = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 290px;
  height: 70px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: #f8f9fa;
  ${DashboardMedia.desktop} {
    width: 700px;
  }

  figure {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33px;
    height: 32px;
    background: #212529;
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const DashForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #212529;
  border-radius: 4px;
  width: 300px;
  height: 420px;
  ${DashboardMedia.desktop} {
    width: 740px;
  }

  button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    width: 280px;
    height: 48px;
    background: #121214;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 14.2123px;
    line-height: 24px;
    color: #f8f9fa;
    margin-top: 16px;
    border: none;
    cursor: pointer;
    ${DashboardMedia.desktop} {
      width: 700px;
      height: 48px;
    }
  }
`;
